import { setupWebSocket } from '../actions/websockets'
import getConnectedHistory from './get-connected-history'
// remove setup-persist.js if not needed anymore and the new setup works
import setupPersist from './setup-persist'
import createReduxStore from './create-redux-store'
import connectWsToDispatch from './connect-ws-to-dispatch'
import config from 'config'

// TODO: Figure out why changing to default export breaks everything
export async function initializeStore(reducers, usePersist = false, useWs = false) {
  const websocket = useWs ? await setupWebSocket({ uri: config.WEB_SOCKET_URI }) : null

  const store = createReduxStore(reducers, usePersist, websocket)

  if (websocket) {
    connectWsToDispatch(websocket, store.dispatch, store.getState)
  }

 // const history = getConnectedHistory(store)
// this does not seem to work anymore, so persist not used for admin. Moved the persist setup to createReduxStore
/*   if (usePersist) {
    setupPersist(store)
  }
 */

  return { store }
}
